import React, { useEffect, useMemo, useState } from 'react';
import { useSettings } from '~/hooks/settings';
import App from '~/layouts/App';
import FloatingVipButton from './components/FloatingVipButton';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';

const About: React.FC = () => {
  const { company } = useSettings();
  const [loading, setLoading] = useState(false);

  const whatsappNumber = useMemo(() => {
    if (!company.phone) return '';
    let phone = company.phone.replaceAll('(', '');
    phone = phone.replaceAll(')', '');
    phone = phone.replaceAll('-', '');
    phone = phone.replaceAll(' ', '');

    return phone;
  }, [company]);

  useEffect(() => {
    setLoading(!company.uid);
  }, [company]);

  return (
    <App loading={loading}>
      <div className="row">
        <div className="col-xl-6 offset-xl-3">
          <div className="card shadow-sm mb-4">
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 mb-4">
                  <p className="mb-2 fw-bold">Telefone:</p>
                  <p>
                    <span>{company.phone}</span>
                    <br />
                    <a
                      target="_blank"
                      href={`https://api.whatsapp.com/send?phone=55${whatsappNumber}&text=`}
                      style={{
                        textDecoration: 'none',
                        fontSize: 12,
                        opacity: 1,
                      }}
                      rel="noopener noreferrer"
                    >
                      <i
                        className="bi bi-whatsapp"
                        style={{ fontSize: 18, color: company.app_color }}
                      />
                      <span
                        style={{
                          marginLeft: 4,
                          color: company.app_color,
                          opacity: 1,
                        }}
                      >
                        Whatsapp
                      </span>
                    </a>

                    <a
                      target="_blank"
                      href={`tel:${whatsappNumber}`}
                      style={{
                        textDecoration: 'none',
                        fontSize: 12,
                        marginLeft: 24,
                      }}
                      rel="noopener noreferrer"
                    >
                      <i
                        className="bi bi-telephone"
                        style={{ fontSize: 18, color: company.app_color }}
                      />
                      <span style={{ marginLeft: 4, color: company.app_color }}>
                        Ligar
                      </span>
                    </a>
                  </p>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <p className="mb-2 fw-bold">E-mail para contato:</p>
                  <p>
                    {company.email}
                    <br />
                    <a
                      target="_blank"
                      href={`mailto:${company.email}`}
                      style={{ textDecoration: 'none', fontSize: 12 }}
                      rel="noopener noreferrer"
                    >
                      <i
                        className="bi bi-envelope"
                        style={{ fontSize: 18, color: company.app_color }}
                      />
                      <span style={{ marginLeft: 4, color: company.app_color }}>
                        E-mail
                      </span>
                    </a>
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 mb-4">
                  <p className="mb-2 fw-bold">Tempo de Entrega:</p>
                  <p>{company.waiting_time}</p>
                </div>
                {company.shipping_cost && company.shipping_cost !== '0' && (
                  <div className="col-12 col-md-6 mb-4">
                    <p className="mb-2 fw-bold">Valor de Entrega:</p>
                    <p>
                      a partir de{' '}
                      {getCurrencyFormatted(
                        parseFloat(`${company.shipping_cost}`),
                      )}
                    </p>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-12 col-md-6 mb-4">
                  <p className="mb-2 fw-bold">Horários de Atendimento:</p>
                  <p style={{ whiteSpace: 'pre-wrap' }}>{company.service_hours}</p>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <p className="mb-2 fw-bold">Endereço:</p>
                  <p>{company.address}</p>
                </div>
              </div>

              {(company.instagram || company.facebook) && (
                <div className="row">
                  <div className="col-12 col-md-6 mb-4">
                    <p className="mb-2 fw-bold">Redes Sociais:</p>
                    {company.instagram && (
                      <a
                        target="_blank"
                        href={company.instagram}
                        style={{ textDecoration: 'none', fontSize: 12 }}
                        rel="noopener noreferrer"
                      >
                        <i
                          className="bi bi-instagram"
                          style={{ fontSize: 18, color: company.app_color }}
                        />
                        <span
                          style={{ marginLeft: 4, color: company.app_color }}
                        >
                          Instagram
                        </span>
                      </a>
                    )}

                    {company.facebook && (
                      <a
                        target="_blank"
                        href={company.facebook}
                        style={{
                          textDecoration: 'none',
                          fontSize: 12,
                          marginLeft: 8,
                        }}
                        rel="noopener noreferrer"
                      >
                        <i
                          className="bi bi-facebook"
                          style={{ fontSize: 18, color: company.app_color }}
                        />
                        <span
                          style={{ marginLeft: 4, color: company.app_color }}
                        >
                          Facebook
                        </span>
                      </a>
                    )}
                  </div>
                </div>
              )}

              {company.latitude && company.longitude && (
                <div className="row">
                  <div style={{ display: 'flex' }}>
                    <p className="mb-2 fw-bold">Como chegar:</p>

                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`https://www.google.com/maps/dir/?api=1&origin=&destination=${company.latitude},${company.longitude}`}
                      style={{
                        textDecoration: 'none',
                        fontSize: 16,
                        marginLeft: 8,
                        color: company.app_color,
                      }}
                    >
                      Ir até a loja
                    </a>
                  </div>
                  <iframe
                    title="map"
                    src={`https://maps.google.com/maps?q=${company.latitude}, ${company.longitude}&z=15&output=embed`}
                    width="360"
                    height="270"
                    frameBorder="0"
                    style={{ border: 0, width: '100%' }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <FloatingVipButton />
    </App>
  );
};

export default About;
